import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';
import { OverlayWrapper, OverlayLogo, OverlayImage } from './EntranceOverlay.style';
import faceRecognitionImage from 'src/domains/players/state/IdMission/IdMissionPopup/assets/faceRecognitionImage.png';

interface EntranceOverlayProps {
    isFadingOut: boolean;
}

export const EntranceOverlay = observer('EntranceOverlay', ({ isFadingOut }: EntranceOverlayProps) => {
    return (
        <OverlayWrapper
            data-test='id-mission-entrance-overlay'
            isFadingOut={isFadingOut}
        >
            <OverlayLogo>
                <UniverseComponent>
                    {(universeVersion): React.ReactElement => <universeVersion.headerLogo />}
                </UniverseComponent>
            </OverlayLogo>
            <OverlayImage
                src={faceRecognitionImage}
                alt='Face recognition illustration'
                width={300}
            />
        </OverlayWrapper>
    );
});
